module.exports = __webpack_public_path__ + "img/Signs.a7717504.jpg";